import React, { useState, Component, useEffect } from "react";
import { Button, Row, Table, Input, Tag, Col } from "antd";
import { Route, Switch, useHistory, withRouter } from "react-router-dom";
import {
  PlusOutlined,
  SearchOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment";
import Title from "components/Title/Title";
import {
  buildPolicyNewUri,
  buildPolicyUri,
  buildPoliciesUri,
} from "utils/routes";
import Policy from "./components/Policy/Policy";
import { getPolicyLibraryList } from "../../apis/policyLibrary";
import { getUserAuthObj } from "../../utils/auth";
import { CSVLink } from "react-csv";
import Locale from "react-intl-universal";
import { useFetchConstant } from "apis/constant";

const Policies = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([
    // {
    //   _id: "1",
    //   company: "Hong Leong Assurance",
    //   product_name: "Complete Cover",
    //   product_type: "Investment - Linked Plan",
    // },
    // {
    //   _id: "2",
    //   company: "Great Eastern",
    //   product_name: "36 Critical Illness",
    //   product_code: "361 (DDDEFN1)",
    //   product_type: "Rider",
    // },
  ]);
  const [searchText, setSearchText] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const { selection: companyList } = useFetchConstant("insuranceCompanies");
  const { selection: productTypeList } = useFetchConstant("productType");
  // Export CSV
  const [csv_data, set_csv_data] = useState([]);
  const [csv_header, set_csv_header] = useState([
    {
      label: "Company Name",
      key: "company",
    },
    {
      label: "Product Name",
      key: "product_name",
    },
    {
      label: "Product Code",
      key: "product_code",
    },
    {
      label: "Product Type",
      key: "product_type",
    },
  ]);

  const history = useHistory();

  const jwt = getUserAuthObj();

  useEffect(() => {
    GetPolicyLibraryList();
  }, []);

  const GetPolicyLibraryList = async () => {
    setLoading(true);
    const res = await getPolicyLibraryList();

    console.log(res);
    setLoading(false);

    setData(res);
    // if (res.status === 200) {
    //   setLoading(false);

    //   setData(res);
    // } else {
    //   setLoading(false);
    // }
  };

  const generateCSV = () => {
    var order = [...data];
    var csv_data = [];
    // var sum_balance = 0;

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];
      console.log(real_order);
      // sum_balance = parseFloat(
      //   parseFloat(sum_balance + real_order.balance).toFixed(2)
      // );

      csv_data.push({
        company: real_order.company,
        product_name: real_order.product_name,
        product_code: real_order.product_code,
        product_type: real_order.product_type,
      });
    }
    // csv_data.push({
    //   balance: sum_balance,
    // });
    set_csv_data(csv_data);
    // this.setState({
    //   csv_data,
    // });
    return true;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          marginRight: 8,
          fontSize: 18,
          color: filtered ? "#ffc069" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      console.log(record);
      if (record[dataIndex]) {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return false;
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput);
      }
    },
    render: (text) => {
      if (text) {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        );
      }
    },
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    // {
    //   title: "Creation Date",
    //   dataIndex: "timestamp",
    //   key: "timestamp",
    //   sorter: (a, b) => a.timestamp - b.timestamp,
    //   sorDirections: ["ascend"],
    //   render: (value) => {
    //     if (value) {
    //       return moment.unix(value).format("DD-MMM-YYYY hh:mm A");
    //     }
    //   },
    // },

    {
      title: Locale.get("Policies.policyComponent.companyName"),
      dataIndex: "company",
      key: "company",
      ...getColumnSearchProps("company"),
      render: (value) => {
        let lookupValue = companyList.find((item) => item.code === value);
        return lookupValue ? lookupValue.label : value;
      },
    },
    {
      title: Locale.get("Policies.policyComponent.productName"),
      dataIndex: "product_name",
      key: "product_name",
      ...getColumnSearchProps("product_name"),
    },
    {
      title: Locale.get("Policies.policyComponent.productCode"),
      dataIndex: "product_code",
      key: "product_code",
      ...getColumnSearchProps("product_code"),
    },
    {
      title: Locale.get("Policies.policyComponent.productType"),
      dataIndex: "product_type",
      key: "product_type",
      filterMultiple: false,
      filters: [
        {
          text: "Traditional Plan",
          value: "traditionalPlan",
        },
        {
          text: "Investment Link Plan",
          value: "investmentLinkPlan",
        },
        {
          text: "Rider",
          value: "rider",
        },
      ],
      onFilter: (value, record) => record.product_type.includes(value),
      render: (value) => {
        let lookupValue = productTypeList.find((item) => item.code === value);
        return lookupValue ? lookupValue.label : value;
      },
    },
  ];
  return (
    <div>
      <div>
        <Switch>
          <Route exact path={buildPoliciesUri()}>
            <div>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginBottom: 32 }}
              >
                <Title>{Locale.get("Policies.pageTitle")}</Title>

                {jwt.role === "admin" ||
                jwt.role === "contributor" ||
                jwt.role === "agent_full_and_contributor" ? (
                  <Row gutter={24}>
                    {jwt.role === "admin" && (
                      <Col>
                        <CSVLink
                          data={csv_data}
                          headers={csv_header}
                          filename={`${moment().format(
                            "DD-MMM-YYYY"
                          )}_PoliciesLibrary.csv`}
                          onClick={generateCSV}
                        >
                          <Button
                            icon={
                              <CloudDownloadOutlined
                                style={{ color: "#d7a301" }}
                              />
                            }
                            style={{ color: "#d7a301", borderColor: "#d7a301" }}
                          >
                            {Locale.get("Policies.csv")}
                          </Button>
                        </CSVLink>
                      </Col>
                    )}

                    <Col>
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                          history.push(buildPolicyNewUri());
                          // history.push(buildPolicyUri("12345678"));
                        }}
                      >
                        {Locale.get("Policies.addNewPolicy")}
                      </Button>
                    </Col>
                  </Row>
                ) : null}
              </Row>

              <Table
                // bordered
                size="large"
                rowKey="_id"
                onRow={(record) => ({
                  onClick: () => history.push(buildPolicyUri(record._id)),
                })}
                columns={columns}
                loading={loading}
                dataSource={data}
                scroll={{ scrollToFirstRowOnChange: true, x: true }}
              />
            </div>
          </Route>
          <Route path={buildPolicyNewUri()}>
            <Policy />
          </Route>
          <Route path={buildPolicyUri()}>
            <Policy />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Policies;

// import { useGetPolicies } from "apis/policy";

// import {
//   getColumnFilterSearchProps,
//   constructColumn,
//   handleOnAggregationTableChange,
// } from "utils/table/table";

// import { PoliciesTable } from "./Policies.styles";

// const Policies = () => {
//   const history = useHistory();
//   const [query, setQuery] = useState({ currentPage: 1, limit: 10 });

//   const {
//     isLoading: isPoliciesLoading,
//     paginatedData: policies,
//     total,
//   } = useGetPolicies(query);

//   const columns = [
//     {
//       ...constructColumn("Plan Name", "name", { hasSorter: true }),
//       ...getColumnFilterSearchProps("name", "Search name"),
//     },
//     {
//       ...constructColumn("Company", "company"),
//     },
//     {
//       ...constructColumn("Type of Plan", "type"),
//     },
//     {
//       ...constructColumn("TPD Waiver", "hasTPDCoverage"),
//       render: (waiver) => (waiver ? "Yes" : "No"),
//     },
//     {
//       ...constructColumn("Critical Illness Waiver", "hasCICoverage"),
//       render: (waiver) => (waiver ? "Yes" : "No"),
//     },
//   ];

//   const handleOnRow = (record) => ({
//     onClick: () => history.push(buildPolicyUri(record._id)),
//   });

//   return (
//     <>

//       <Switch>
//         <Route exact path={buildPoliciesUri()}>
//           <div>
//
//             <PoliciesTable
//               isLoading={isPoliciesLoading}
//               columns={columns}
//               dataSource={policies}
//               onRow={handleOnRow}
//               onChange={(pagination, filters, sorter) =>
//                 handleOnAggregationTableChange(
//                   { pagination, filters, sorter },
//                   setQuery
//                 )
//               }
//               pagination={{ total, current: query.currentPage }}
//               rowKey={(record) => record._id}
//               showSorterTooltip={false}
//             />
//           </div>
//         </Route>
//         <Route path={buildPolicyNewUri()}>
//           <Policy />
//         </Route>
//         <Route path={buildPolicyUri()}>
//           <Policy />
//         </Route>
//       </Switch>
//     </>
//   );
// };

// export default Policies;
